var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4246 12.4444H13.1397V43.5556H44.4246V12.4444Z",
    fill: "#F7DF1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1552 36.7501C34.7854 37.7733 35.6053 38.5254 37.0553 38.5254C38.2734 38.5254 39.0516 37.92 39.0516 37.0835C39.0516 36.081 38.2521 35.7259 36.9113 35.1427L36.1763 34.8291C34.0549 33.9304 32.6456 32.8044 32.6456 30.4242C32.6456 28.2316 34.3256 26.5625 36.951 26.5625C38.8202 26.5625 40.1639 27.2094 41.1323 28.9032L38.843 30.3649C38.339 29.4662 37.7952 29.1121 36.951 29.1121C36.0899 29.1121 35.5442 29.6553 35.5442 30.3649C35.5442 31.242 36.0904 31.597 37.3518 32.1402L38.0867 32.4533C40.5845 33.5185 41.9948 34.6044 41.9948 37.0459C41.9948 39.678 39.9156 41.12 37.1233 41.12C34.3931 41.12 32.6292 39.8262 31.7662 38.1304L34.1552 36.7501ZM23.7701 37.0035C24.2319 37.8183 24.6521 38.5072 25.6621 38.5072C26.628 38.5072 27.2373 38.1314 27.2373 36.6701V26.7294H30.1771V36.7096C30.1771 39.7368 28.3923 41.1146 25.7873 41.1146C23.4334 41.1146 22.0703 39.9032 21.3771 38.4442L23.7701 37.0035Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.cebc4c8ba973931c3bad5ed84f65634a.svg";
export { ForwardRef as ReactComponent };